<template>
  <div class="animated fadeInUp" id="not-found">
    <div class="section is-relative mockup-section">
      <div class="container">
        <div class="column error-wrap error-centered has-text-centered">
          <div class="column is-6 is-offset-3 z-index-2">
            <div class="bg-404">404</div>
            <img src="images/illustrations/errors/2.svg" alt="" />
            <div class="error-caption">
              <h2>We couldn't locate the page.</h2>
              <p>Please contact the website administrator to get some help.</p>
              <div class="button-wrap">
                <a
                  @click.prevent="home()"
                  class="button button-cta btn-primary is-bold btn-align secondary-btn rounded raised"
                >
                  <i class="fas fa-home"></i> Back to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { APPLICATION_KEY, jetPayNowApi } from '../api/jetpaynow_api';

export default {
  name: '404',
  mounted() {
    this.$root.$emit('stickyHeaderHandler', true);
  },
  methods: {
    home() {
      // window.location = `${process.env.VUE_APP_WEB_URL}`;
      this.$router.push('/', () => {});
    },
    register() {
      // window.location = `${process.env.VUE_APP_WEB_URL}/register`;
      this.$router.push('/register', () => {});
    },
    forgotPass() {
      // window.location = `${process.env.VUE_APP_WEB_URL}/forgot-password`;
      this.$router.push('/login', () => {});
    },
  },
};
</script>
<style scoped>
/*Injected Landing Page Css*/
@import '../../public/css/core.css';
@import '../../public/css/core_responsive.css';
@import '../../public/css/ggtooltip.css';

body {
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
  color: #444f60;
}

.error-wrap.error-centered .bg-404 {
  position: absolute;
  top: 40%;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 25rem;
  font-weight: 700;
  color: rgba(68, 79, 96, 0.15);
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  z-index: 0;
}
.error-wrap.error-centered .error-caption h2 {
  color: #444f60;
  font-family: 'Roboto', sans-serif;
  font-size: 2rem;
  max-width: 560px;
  margin: 0 auto;
}
.error-wrap.error-centered .error-caption p {
  color: #1d6ea3;
  font-size: 1.36rem;
}

.hero-body .title.big-title {
  color: #444f60;
  z-index: 999;
  font-size: 4rem;
}
.light-subtitle {
  font-size: 1.5rem;
  padding: 2% 10% 2% 10%;
  margin-bottom: 0 !important;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.button-cta {
  font-weight: 500;
  line-height: normal;
  font-family: Roboto, sans-serif;
  font-size: 1.5rem !important;
  margin: auto;
  padding: 22px !important;
}
.footer-cta {
  font-size: 2.5rem !important;
  font-weight: 500;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.video-link {
  font-size: 1.4rem !important;
}
span {
  font-weight: 500;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.side-block .background-wrapper .video-wrapper .playbutton {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -43px;
  cursor: pointer;
}
.footer-button-cta {
  background: #00a57f;
  color: #fff !important;
  margin: auto;
  padding: 22px 4px 22px 22px !important;
  font-weight: 500;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.footer-button-cta:hover,
.button-cta:hover {
  background: #00a27f;
  cursor: pointer;
  color: #fff !important;
}
.modal.is-active .modal-close {
  z-index: 100 !important;
}
.modal .modal-close:hover {
  transform: rotate(135deg);
}
.modal .modal-close {
  transition: all 0.4s;
  z-index: 100 !important;
  width: 35px !important;
  height: 35px !important;
  padding: 5px !important;
}
.minimal-feature .minimal-title {
  font-family: 'Nexa Bold', sans-serif;
  font-size: 3.1rem;
  font-weight: 500;
  color: #444f60;
  padding: 10px 0;
  margin-bottom: 0 !important;
}
.feature-content,
.footer-description {
  margin-top: 0;
  color: #4a4a4a;
  font-size: 1.7rem;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
.m-20 {
  margin: 20px auto;
}
footer.footer-light-medium .footer-column {
  padding-top: 0;
  margin-top: -10px;
  list-style: none;
  font-family: Roboto, sans-serif;
}
.footer.footer-light-medium .footer-column .column-header {
  font-weight: 600;
  font-size: 15px;
  font-family: Roboto, sans-serif;
}
.button.primary-btn:hover {
  background: #00a57f !important;
  color: #fff !important;
}
footer.footer-light-medium .small-footer-logo {
  height: 40px;
}
footer.footer-light-medium .footer-description {
  color: #1a1a1a;
  font-weight: normal;
}
.feature-content,
.footer-description {
  margin-top: 0;
  color: #1a1a1a;
  font-size: 1.7rem;
  font-weight: 400;
  line-height: normal;
  font-family: Roboto, sans-serif;
}
footer.footer-light-medium .footer-column .column-item a {
  color: #1a1a1a;
  font-weight: normal;
}
footer ul li a {
  color: #0d0d0d;
  font-family: Roboto, sans-serif;
}
.icon {
  display: inline-block;
  font-size: 21px;
  padding-top: 3px;
  height: 30px;
  width: 30px;
  text-align: center;
  vertical-align: top;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
icon:hover {
  -webkit-box-shadow: 0 0 3px rgba(21, 21, 21, 0.3);
  -moz-box-shadow: 0 0 3px rgba(21, 21, 21, 0.3);
  box-shadow: 0 0 3px rgba(21, 21, 21, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.icon i {
  color: rgba(0, 0, 0, 0.1);
}
.icon i:hover {
  color: #00a27f;
  cursor: pointer;
}
#backtotop a {
  outline: none;
  text-decoration: none;
  border: 0 none;
  display: block;
  width: 46px;
  height: 46px;
  background-color: #66676b;
  opacity: 1;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-radius: 3px;
  text-align: center;
  font-size: 26px;
}
.copyright-block {
  background-color: #00a57f;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 14px;
}
</style>
